// @ts-strict-ignore
import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';

import { CurrentUser } from 'api/currentUser';
import { hideModal, showModal } from 'store/main/ducks/modal';
import { deleteCookie, getCookieValue } from 'utils/cookies';

type OwnProps = {
  children: ReactNode;
};
type Props = OwnProps &
  RouteComponentProps & {
    currentUser: CurrentUser;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    modal: Record<string, any>;
    showModal: typeof showModal;
    hideModal: typeof hideModal;
  };

class ShowUserModals extends React.PureComponent<Props> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/sort-comp
  verify() {
    const { currentUser, location, modal } = this.props;
    const verifyEmail = !!currentUser.email && !currentUser.emailVerified;

    if (verifyEmail && !modal.type && location.pathname === '/survey/report') {
      return;
    }

    if (verifyEmail) {
      // INFORMATION_REQUIRED excepted for case of Facebook user not allowing
      // their email address and then has just filled one in.
      if (!modal.type || modal.type === 'INFORMATION_REQUIRED') {
        // only show the modal if another isn't already shown
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.showModal('VERIFY_EMAIL');
      }

      return;
    }

    if (modal.type === 'VERIFY_EMAIL') {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.hideModal();
    }

    if (getCookieValue('justSignedUpModal') && !modal.type) {
      const method = getCookieValue('justSignedUpModal');

      if (method === 'Google' || method === 'Facebook') {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.showModal('FINISH_OAUTH_SIGNUP', {
          onClose: () => deleteCookie('justSignedUpModal'),
        });
      } else {
        deleteCookie('justSignedUpModal');
      }

      return;
    }

    const informationRequired =
      currentUser.id &&
      (!currentUser.firstName || !currentUser.lastName || !currentUser.email) &&
      location.pathname !== '/dashboard/account-settings';

    if (informationRequired) {
      if (!modal.type) {
        // only show the modal if another isn't already shown
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.showModal('INFORMATION_REQUIRED');
      }

      return;
    }

    if (modal.type === 'INFORMATION_REQUIRED') {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.hideModal();
    }

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.currentUser.showNotifPrefModal) {
      if (!modal.type) {
        // only show the modal if another isn't already shown
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.showModal('NOTIFICATION_PREFERENCES');
      }

      return;
    }

    if (modal.type === 'NOTIFICATION_PREFERENCES') {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.hideModal();
    }
  }

  componentDidMount() {
    this.verify();
  }

  componentDidUpdate() {
    this.verify();
  }

  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment,react/jsx-no-useless-fragment
    return <>{this.props.children}</>;
  }
}

const mapStateToProps = ({ currentUser, modal }) => ({
  currentUser,
  modal,
});

// eslint-disable-next-line import/no-default-export
export default withRouter(
  connect(mapStateToProps, {
    showModal,
    hideModal,
  })(ShowUserModals)
);
